var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderOpen03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "folder-open-03"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M4.49985 4.84979V3.34979C4.49985 2.79751 4.94756 2.34979 5.49985 2.34979H14.9998C15.5521 2.34979 15.9998 2.79751 15.9998 3.34979V7.34979M2.00063 16.4673L2.0007 8.8637C2.00071 8.10209 2.00043 7.01732 2.00018 6.23186C2.00001 5.67943 2.44779 5.23212 3.00022 5.23212H7.7654L10.0696 7.69348H16.9998C17.5521 7.69348 17.9998 8.14121 17.9998 8.69351L17.9996 16.4674C17.9995 17.5719 17.1041 18.4673 15.9996 18.4673L4.00062 18.4673C2.89605 18.4673 2.00062 17.5719 2.00063 16.4673Z",
    stroke: "#7F7D83",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpen03);
export default __webpack_public_path__ + "static/media/folder-open-03.cd0b5e737f0e7813956dfed5682aae2f.svg";
export { ForwardRef as ReactComponent };